import Ajax from '@/lib/ajax'

export default {
    getMpUserInfoReport(beginTime: string, endTime: string) {
        return Ajax.get('/api/WeChatManagement/MpUserReport', {
            params: {
                BeginTime: beginTime,
                EndTime: endTime
            }
        })
    },
    /**
     * 获取粉丝列表
     */
    getList(pageSize: number, currentPage: number, sorting?: string, fromShop?: boolean, shopCode?: string) {
        let params = {
            Sorting: sorting,
            FromShop: fromShop,
            ShopCode: shopCode,
            MaxResultCount: pageSize,
            SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
        }
        return Ajax.get(`/api/WeChatManagement/MpUser`, {
            params: params
        })
    },
    /**
     * 获取运营数据
     */
    getOperationalData(StartTime: string, EndTime: string) {
        let params = {
            StartTime: StartTime,
            EndTime: EndTime,
        }
        return Ajax.get('/api/Report/OperationalData', {
            params: params
        })
    },
    /**
     * 获取产品销售排行数据 
     */
    getProductSalesData(StartTime: string, EndTime: string, pageSize: number, currentPage: number) {
        let params = {
            StartTime: StartTime,
            EndTime: EndTime,
            MaxResultCount: pageSize,
            SkipCount: currentPage <= 1 ? 0 : (currentPage - 1) * pageSize
        }
        return Ajax.get('/api/Report/ProductSale/SaleRank', {
            params: params
        })
    },
    /**
     * 获取交易分析数据
     */
    getTransactionAnalysisData(StartTime: string, EndTime: string) {
        let params = {
            StartTime: StartTime,
            EndTime: EndTime
        }
        return Ajax.get('/api/Report/Transaction', {
            params: params
        })
    },
    /**
     * 获取浏览来源排行数据
     */
    getTrafficSourceData(StartTime: string, EndTime: string) {
        let params = {
            StartTime: StartTime,
            EndTime: EndTime
        }
        return Ajax.get('/api/Report/TrafficAnalysis/TrafficSource', {
            params: params
        })
    },
}